import {grayColors} from "../../../architecture/gray-colors";

export const baseColors = {
    base01: "#FC6200",
    base01Contrast: "#000000",
    base01Dark: "#de5600",
    base01Light: "#fc721a",

    base02: "#FFCC00",
    base02Contrast: "#000000",
    base02Dark: "#e0b400",
    base02Light: "#ffd11a",

    base03: "#e91515",
    base03Contrast: "",
    base03Dark: "#cd1212",
    base03Light: "#eb2c2c",

    base04: "#0294f6",
    base04Contrast: "#ffffff",
    base04Dark: "#0282d8",
    base04Light: "#1b9ff7",

    base05: "#0c0c0c",
    base05Contrast: "#ffffff",
    base05Dark: "#0b0b0b",
    base05Light: "#242424",

    ...grayColors
}